import { FC, useRef, useState } from 'react';
import { SellOutlined } from '@mui/icons-material';
import { IconButton, Tooltip, Typography } from '@mui/material';
import ProductCatalogModal from './ProductCatalogModal';

const MessageComposerProductCatalog: FC = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const productCatalogButtonRef = useRef<HTMLButtonElement>(null);

  const handleClick = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Tooltip
        title={<Typography>Share products</Typography>}
        arrow
        placement="top"
      >
        <IconButton onClick={handleClick} ref={productCatalogButtonRef}>
          <SellOutlined />
        </IconButton>
      </Tooltip>
      <ProductCatalogModal
        onClose={handleClose}
        isOpen={isModalOpen}
        anchorRef={productCatalogButtonRef}
      />
    </>
  );
};

export default MessageComposerProductCatalog;
